import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 5px 9px;
  background-color: ${({ theme }) => theme.palette.backgrounds.pill};
`;

export const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 80%;
`;

export const ListWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  width: fit-content;
  margin-top: 10px;
`;

export const Space = styled.div`
  margin-top: 10px;
`;

export const CheckboxesWrapper = styled.div`
  margin: 10px 0px;
`;
